import {
  getSubtitleApplyCheck,
  getSubtitlePluginPath,
  getSubtitleRequestList,
  getSubtitleStreamKey,
  postSubtitleRefreshStreamKey,
  postSubtitleRequestHangul,
} from '@module/apis/client-side/subtitle';
import type {
  SubtitleApplyCheckResponse,
  SubtitlePluginPathResponse,
  SubtitlePluginPathType,
  SubtitleRequestHangulParams,
  SubtitleRequestHangulResponse,
  SubtitleRequestListResponse,
  SubtitleStreamKeyResponse,
} from '@module/apis/client-side/subtitle/type';
import { type UseMutationOptions, useMutation, useQuery } from '@tanstack/react-query';
import type { CustomUseQueryOptions } from '../type';
import { subtitleQueryKeys } from './subtitleQueryKeys';

export const useGetSubtitleRequestListQuery = (options?: CustomUseQueryOptions<SubtitleRequestListResponse, Error>) =>
  useQuery({
    queryKey: subtitleQueryKeys.getSubtitleRequestList().queryKey,
    queryFn: () => getSubtitleRequestList(),
    ...options,
  });

export const useGetSubtitleApplyCheckQuery = (options?: CustomUseQueryOptions<SubtitleApplyCheckResponse, Error>) =>
  useQuery({
    queryKey: subtitleQueryKeys.getSubtitleApplyCheck().queryKey,
    queryFn: () => getSubtitleApplyCheck(),
    ...options,
  });

export const useGetSubtitlePluginPathQuery = (
  { type }: { type: SubtitlePluginPathType },
  options?: CustomUseQueryOptions<SubtitlePluginPathResponse, Error>,
) =>
  useQuery({
    queryKey: subtitleQueryKeys.getSubtitlePluginPath(type).queryKey,
    queryFn: () => getSubtitlePluginPath({ type }),
    ...options,
  });

// pandalive 일본어 닉네임 한글 번역
export const usePostSubtitleRequestHangulMutation = (
  options?: UseMutationOptions<SubtitleRequestHangulResponse, Error, SubtitleRequestHangulParams>,
) =>
  useMutation({
    mutationKey: subtitleQueryKeys.postSubtitleRequestHangul().queryKey,
    mutationFn: (params: SubtitleRequestHangulParams) => postSubtitleRequestHangul(params),
    ...options,
  });

export const useGetSubtitleStreamKeyQuery = (options?: CustomUseQueryOptions<SubtitleStreamKeyResponse, Error>) =>
  useQuery({
    queryKey: subtitleQueryKeys.getSubtitleStreamKey().queryKey,
    queryFn: () => getSubtitleStreamKey(),
    ...options,
  });

export const usePostSubtitleRefreshStreamKeyMutation = (
  options?: UseMutationOptions<SubtitleStreamKeyResponse, Error>,
) =>
  useMutation({
    mutationKey: subtitleQueryKeys.postSubtitleRefreshStreamKey().queryKey,
    mutationFn: () => postSubtitleRefreshStreamKey(),
    ...options,
  });
